module.exports = __webpack_public_path__ + "static/media/Caixa5.d533e527.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/RelCaixa/Caixa5.png
// module id = 2034
// module chunks = 0